<!--
  @description 模糊搜索事项
  @author cjs1992
  @date 2020-08-20 10:44:18
-->
<template>
   <el-select
    v-bind="$attrs"
    v-model="val"
    filterable
    remote
    reserve-keyword
    clearable
    placeholder="请输入"
    :remote-method="remoteMethod"
    :loading="loading">
    <el-option
      v-for="item in options"
      :key="item.portalPcHandlingGidelineId"
      :label="item.portalPcHandlingGuidelineName"
      :value="item.portalPcHandlingGidelineId">
    </el-option>
  </el-select>
</template>
<script>
import { getGuidelineByCon } from "@/api/feedBack.js";
export default {
  props: {
    value: {
      type: [Number, String],
      default: ""
    }
  },
  data() {
    return {
      val: "",
      options: [],
      loading: false
    };
  },
  watch: {
    val() {
      this.$emit("input", this.val);
    },
    value() {
      if (this.val === this.value) {
        return;
      }
      this.val = this.value;
      if (this.val) {
        this.remoteMethod(this.val, 1);
      }
    }
  },
  mounted() {
    this.val = this.value;
    if (this.val) {
      this.remoteMethod(this.val, 1);
    }
  },
  methods: {
    /**
     * @name remoteMethod
     * @description 远程搜索方法
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-08-20 10:52:43
     */
    async remoteMethod(query, flag) {
      const q = String(query).trim();
      if (q === "") {
        return;
      }
      let obj = { // eslint-disable-line
        startPage: 1,
        pageSize: 10,
        guidelineId: "",
        guidelineName: ""
      };
      if (flag === 1) {
        // id
        obj.guidelineId = query;
      } else {
        obj.guidelineName = q;
      }
      this.options = [];
      const res = await getGuidelineByCon(obj);
      this.options = res.data.list || [];
    }
  }
};
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/yjfk/select-matter.vue